/**
 * Formats a price in cents to a display string (e.g. $18.95/mo).
 * Currency defaults to USD.
 */
export function formatPriceCents(cents, options = {}) {
    const { currency = "CAD", interval, suffix } = options;
    const symbol = currency === "CAD" ? "$" : currency === "EUR" ? "€" : "£";
    const amount = (cents / 100).toFixed(2);
    const intervalStr = interval === "monthly" ? "/mo" : interval === "yearly" ? "/yr" : "";
    const extra = suffix ? ` ${suffix}` : "";
    return `${symbol}${amount}${intervalStr}${extra}`;
}
